































import { Vue, Component, Prop } from 'vue-property-decorator';

import InfoIcon from '@/components/icons/Info.vue';

@Component({
  components: {
    InfoIcon
  }
})
export default class ReportItem extends Vue {
  @Prop() title!: string;
  @Prop() value!: string;
  @Prop() tooltipText!: string;
  @Prop() tooltipColor?: string;
  @Prop() tooltipInteractive?: boolean;
}
